// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__VYovf","inner":"styles_inner__CERwF"};
module.exports.__checksum = "d541b75014d4"
